/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { MdEdit } from '@react-icons/all-files/md/MdEdit';
import { MdDelete } from '@react-icons/all-files/md/MdDelete';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import ClassNames from 'classnames';

import ProductTileCart from '../ProductTileCart';
import { FormattedMessage, useIntl } from 'react-intl';
import { removeFromCartGA, removeItemGA } from 'spwa-ui-library/esm/utils/helperGA.js';
import css from './index.module.scss';
// SPWA IMPORTS
const { removeItemCart, reduceItem, cartItems } = Slices.cartSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { couponCodeApplied, offerApplied, removeApply } = Slices.offerSlice;
const { selectProductEntities, getProductInfo } = Slices.productSlice;
const { getClusterId } = Slices.configSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { updateProductPayload } = Slices.tempCartSlice;

import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';

function CartItemList({
  miniCart,
  itemList,
  editMode,
  index,
  setReviewCart,
  handleCart,
  freeItems = [],
  setErrMsg,
  setCartReview,
}) {
  const [deleteItem, setDeleteItem] = React.useState();
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const productsMap = useSelector(selectProductEntities);
  const menu = useSelector(selectFirstMenu);
  const categoryInfo = useSelector((state) => state.category);
  const currency = menu && menu.currency;
  const couponSelected = useSelector(couponCodeApplied);
  const offerSelected = useSelector(offerApplied);
  const cart = useSelector((state) => state.cart);
  const itemsOnCart = useSelector(cartItems);
  const address = useSelector(selectDefaultAddress);
  const clusterId = useSelector(getClusterId);
  const [errorState, setErrorState] = useState(false);
  const [tileError, setTileError] = useState('');

  const tempItems = useSelector((state) => state.tempCart);

  const navigate = useNavigate();
  useEffect(() => {
    if (errorState) {
      setErrMsg && setErrMsg(tileError);
      setCartReview && setCartReview(errorState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorState]);
  // eslint-disable-next-line no-unused-vars
  let reviewCart = false;
  let notAvaialbe = [];
  const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase()?.replace(/\s/g, '-'));
  const handleRoute = (product, idx) => () => {
    navigate(
      `/${intl.locale}/customize/${URLEncode(product.name)}/${product.id || product?.catId}/${idx}`,
      {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
        },
      }
    );
  };

  // HANDLE DELETE METHOD FOR LOCALLY MANAGEMENT
  const handleDelete = (idx) => () => {
    setDeleteItem(idx);
    removeProduct(idx);
  };

  // HANDLE REMOVE PRODUCT ITEM
  const removeProduct = (idx) => {
    const isFreeItem = freeItems?.indexOf(itemList[idx]?.id) > -1;
    if (isFreeItem) {
      dispatch(removeApply());
    }
    const isDiscountedItem =
      cart?.data?.promo?.couponType === 'discountItem' &&
      itemList[idx].catId === cart?.data?.promo?.categoryId;
    if (isDiscountedItem) {
      dispatch(removeApply());
    }
    const categorySelected = categoryInfo.entities[itemList[idx]?.catId];
    setDeleteItem();
    dispatch(reduceItem({ index: idx }));
    removeFromCartGA(itemList[idx], currency, categorySelected, 'ProductCartPage');
    removeItemGA(itemList[idx], currency, categorySelected);
  };

  const handleEditButton = (product, idx) => {
    window.localStorage.setItem('notShowBogoPopup', true);
    const productObj = productsMap[product?.id] || productsMap[product?.catId];
    const categorySelected = categoryInfo.entities[productObj?.categories?.[0]];
    dispatch(
      getProductInfo({
        id: productObj?.id,
        cluster: clusterId,
        service: address?.addressSubType || 'DELIVERY',
        categoryId: productObj?.categories[0],
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then(() => {
      let productRoute = generateProductRoute({
        product: productObj,
        category: categorySelected,
        locale: intl.locale.toLowerCase(),
      });

      let routeOptions = '';

      let tempProductCustomization = JSON.parse(JSON.stringify(itemList[idx]));

      if (productObj?.isBOGO) {
        tempProductCustomization['typeId'] = 'bundle';
        tempProductCustomization['id'] = tempProductCustomization['catId'];
        tempProductCustomization['catId'] = tempProductCustomization['additionalInfo']?.['catId'];
        tempProductCustomization['bundle'] =
          tempProductCustomization?.['additionalInfo']?.['bundle'] || {};
        for (let [step, prod] of Object.entries(tempProductCustomization['bundle'])) {
          if (!prod?.items) {
            let stepInfo = tempProductCustomization?.subItem?.find((s) => s?.stepId == step);
            let productId = Object.keys(prod)[0];
            tempProductCustomization['bundle'][step][productId]['items'] = stepInfo?.items || {};
          }
        }
      } else if (productObj?.bundleTypeId == 'bundle' && productObj?.typeId == 'simple') {
        tempProductCustomization['bundle'] = tempProductCustomization['items'];
        tempProductCustomization['typeId'] = 'bundle';
        delete tempProductCustomization['items'];
      } else if (productObj?.bundleTypeId == 'bundle_group') {
        let bundleId = tempProductCustomization?.id;
        tempProductCustomization['typeId'] = 'bundle';
        tempProductCustomization['id'] =
          tempProductCustomization?.additionalInfo?.bundleGroupId ||
          tempProductCustomization['parentId'];
        tempProductCustomization['additionalInfo'] = {
          selectedBundleId: bundleId,
        };
      }

      if (productObj?.isBOGO) {
        let bundleKey = parseInt(Object.keys(tempProductCustomization?.bundle || {})[0]);
        const optionId = (bundleKey - (bundleKey % 10)) / 10;
        routeOptions = `&bundleGroup=1&option=${optionId}`;
        dispatch(updateProductPayload({ data: tempProductCustomization }));
      } else {
        dispatch(updateProductPayload({ data: tempProductCustomization }));
      }

      if (tempProductCustomization?.additionalInfo?.selectedBundleId && !productObj?.isBOGO) {
        // handle wingstreet, wow tripes etc.
        let mainProductInfo = productsMap[tempProductCustomization?.id];
        let mainProductCategory = categoryInfo.entities[mainProductInfo?.categories?.[0]];

        productRoute = generateProductRoute({
          product: mainProductInfo,
          category: mainProductCategory,
          locale: intl.locale.toLowerCase(),
        });
        routeOptions = `&bundleGroup=1&option=${productObj?.sel1Value}`;
      }

      // update product info in tempCart/data from cart.
      // dispatch(updateProductPayload({ data: product }));

      if (productObj['bundleTypeId'] == 'configurable' || productObj?.typeId == 'simple') {
        navigate(`${productRoute}?cartId=${idx}${routeOptions}`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
            description: intl.formatMessage({ id: 'customize_your_meals' }),
          },
        });
      } else {
        // bundle or bundle_group
        navigate(`${productRoute}/bundle?cartId=${idx}${routeOptions}`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
          },
        });
      }
    });
  };

  React.useEffect(() => {
    if (notAvaialbe.length) {
      if (setReviewCart) {
        setReviewCart((prev) => true);
      }
    } else {
      if (setReviewCart) {
        setReviewCart((prev) => false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notAvaialbe]);

  const checkForFreeProductInPromo = () => {
    let isExist = false;
    let index = -1;

    itemsOnCart.forEach((itm, idx) => {
      if (itm.freeItem) {
        isExist = true;
        index = idx;
      }
    });

    // for (let i = 0; i < cart?.data?.items.length; i++) {
    //   if (offerSelected?.freeItems?.indexOf(cart?.data?.items[i].sku) > -1) {
    //     isExist = true;
    //     index = i;
    //   }
    // }
    return { index, isExist };
  };
  React.useEffect(() => {
    if (!cart?.data?.promo?.id) {
      const freeItem = checkForFreeProductInPromo();
      if (freeItem.isExist && couponSelected) {
        dispatch(removeItemCart({ id: freeItem.index }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsOnCart]);

  const totalQty =
    itemsOnCart.reduce((acc, item) => acc + (item?.qty || 1), 0) || itemsOnCart.length;

  return (
    <>
      <div className={ClassNames(css.root, { [css.miniCartListItems]: miniCart })}>
        {!location.pathname.includes('cart') && (
          <span className={css.cartTitle}>
            <FormattedMessage
              id="cart_multiple_item_add"
              values={{
                count: totalQty,
              }}
            />
          </span>
        )}

        {itemList.map((product, idx) => {
          const hideCustomize =
            product.typeId === 'simple' ||
            (product.typeId === 'configurable' && product.inSide === 0)
              ? false
              : true;
          const menuItem = productsMap[product.id || product?.catId] || product;
          let notAvailble = false;
          const upsellItem = cart?.upsellCategory?.find(
            (item) => item?.id === (product.id || product?.catId)
          );
          // removed check if item available in the menu. [if item is not in menu we will get error from backend]
          if (product.errMsg && product.errMsg !== '') {
            notAvailble = true;
            reviewCart = true;
            notAvaialbe.push(product.id || product?.catId);
          }

          const indexOfFree = checkForFreeProductInPromo().index;
          const isFreeItem = indexOfFree === idx;
          const isDiscountedItem =
            cart?.data?.promo?.couponType === 'discountItem' &&
            product.catId === cart?.data?.promo?.categoryId;
          return (
            <div className={css.cartItemWrapper} key={idx}>
              {editMode && (
                <div className={css.editCart}>
                  {!isFreeItem && !isDiscountedItem && (
                    <>
                      {hideCustomize && (
                        <Button
                          onClick={() => {
                            handleEditButton(product, idx);
                          }}
                        >
                          <MdEdit size="14px" />
                        </Button>
                      )}
                    </>
                  )}
                  <Button onClick={handleDelete(idx)}>
                    <MdDelete />
                  </Button>
                </div>
              )}
              <div className={css.cartItemData}>
                <ProductTileCart
                  setErrorState={setErrorState}
                  setTileError={setTileError}
                  cartItem={product}
                  menuItem={menuItem}
                  handleDelete={handleDelete(idx)}
                  miniCart={miniCart}
                  cartIndex={idx}
                  className="cartItem"
                  productObj={
                    productsMap[product?.id] ||
                    productsMap[product?.catId] ||
                    cart?.upsellCategory?.find((item) => item.id == (product.id || product?.catId))
                  }
                  onCustomize={() => {
                    handleEditButton(product, idx);
                  }}
                  handleCart={handleCart}
                  isFreeItem={isFreeItem}
                  cartPromo={cart?.data?.promo}
                  isDiscountedItem={isDiscountedItem}
                />
              </div>
              {notAvailble ? (
                <div className={css.notAvail}>
                  <h4>
                    <FormattedMessage id="item_not_available" defaultMessage="Item not available" />
                  </h4>
                  <Button variant="outlined" onClick={handleDelete(idx)}>
                    <FormattedMessage id="cart_remove" defaultMessage="Remove" />
                  </Button>
                </div>
              ) : (
                ''
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default CartItemList;
